import React from 'react';
import moment from 'moment';
import { formatDatetime } from '../../../utils';

const GenerateDamageReport = ({
    reportType,
    userStation,
    createdBy,
    createdAt,
    comments,
    images,
    title
}) => {

    return (
            <div dangerouslySetInnerHTML={{__html: (reportType && userStation && createdBy && images) && `
                <html>
                    <head>
                        <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossorigin="anonymous">
                    </head>
                    <body>
                        <style>
                            body {
                                border: 20px solid white;
                                -webkit-print-color-adjust: exact !important;
                            }
                
                            .bg-blue {
                                background-color: 	rgb(64, 159, 216) !important;
                            }
                
                            .bg-grey {
                                    background-color: 	rgb(225, 221, 220) !important;
                            }
                
                            .slanting-line {
                                height: 24px;
                                width: 10px;
                                position: relative;
                                top: -5px;
                            }
                
                            .table-row-info {
                                text-align: center;
                                display: inline-block;
                            }
                
                            tbody tr:nth-child(odd){
                                background-color: #c9c2c0;
                            }
                
                            tbody tr:nth-child(even){
                                background-color: #e1dddc;
                            }
                
                            .table th {
                                background-color:	rgb(64, 159, 216) !important;
                                color: white !important;
                            }
                
                            .img-small {
                                width: '10px';
                                height: auto;
                            }
                
                            .text-blue {
                                color: rgb(64, 159, 216)
                            }
                
                            .test-background {
                                background-color: #f17150 !important;
                            }
                
                            /* * {
                                border: 1px solid red;
                            } */
                
                            .text-white-custom {
                                color: white !important;
                            }
                
                            @media print {
                
                                @page {                
                                    size: A4;
                                    margin: 0mm;
                                }
                
                                html, body, .row {
                                    width: 1024px;
                                }
                
                                body {
                                    margin: 0 auto;
                                }
                
                                .bg-blue {
                                    background-color:	rgb(64, 159, 216) !important;
                                }
                
                                .bg-grey {
                                    background-color: 	rgb(225, 221, 220) !important;
                                }
                
                                .table th {
                                    background-color:	rgb(64, 159, 216) !important;
                                    color: white !important;
                                }
                
                                tbody>tr:nth-child(odd)>td {
                                    background-color: #c9c2c0 !important;
                                }
                
                                tbody>tr:nth-child(even)>td {
                                    background-color: #e1dddc !important;
                                }
                
                                .text-blue {
                                    color: rgb(64, 159, 216) !important;
                                }
                
                                .text-white-custom {
                                    color: white !important;
                                }
                
                                .test-background {
                                    background-color: #f17150 !important;
                                }

                                .image-container {
                                    display: flex !important;
                                    flex-wrap: wrap !important;
                                    gap: 10px !important; /* Space between images */
                                }

                                .image-container img {
                                    flex: 1 1 calc(1100px - 10px) !important; /* 1/3 of the width, accounting for the gap */
                                    max-width: calc(1100px - 10px) !important;
                                    height: auto !important; /* Maintain aspect ratio */
                                    object-fit: cover !important; /* Optional: ensures images fill their space */
                                }
                
                            }
                        </style>
                        <div class='container-fluid' style='margin-top: 20px; '>
                            <div class='row'>
                                <div class='col-xs-4' style='padding-left: 0px;'>
                                    <img src='https://ewrstorage1.blob.core.windows.net/pics/choice.pod.logo.01.png' style='width: 300px; height: auto' />
                                </div>
                                <div class='col-xs-2'>
                                    <img style='width: 100px; height: auto;' src='https://ewrstorage1.blob.core.windows.net/pics/choice.pod.add.01.png' />
                                    <h6>${userStation.s_address}</h6>
                                </div>
                                <div class='col-xs-2'>
                                    <img style='width: 100px; height: auto;' src='https://ewrstorage1.blob.core.windows.net/pics/choice.pod.phone.01.png' />
                                    <h6>${userStation.s_phone}</h6>
                                </div>
                                <div class='col-xs-2'>
                                    <img style='width: 100px; height: auto;' src='https://ewrstorage1.blob.core.windows.net/pics/choice.pod.email.01.png' />
                                    <h6></h6>
                                </div>
                                <div class='col-xs-2'>
                                    <img style='width: 100px; height: auto;' src='https://ewrstorage1.blob.core.windows.net/pics/choice.pod.web.01.png' />
                                    <h6>www.choice.aero</h6>
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-xs-1'>
                                    <div class='row'>
                                        <h3 style='font-weight: bold;'>${reportType} REPORT</h3>
                                    </div>
                                    <div class='row'>
                                        <p>Created by:<p>
                                    </div>
                                    <div class='row'>
                                        <h3 style='font-weight: bold; margin-top: 0'>${createdBy}</h3>
                                    </div>
                                    <div class='row'>
                                        <p>
                                            Date Reported: ${formatDatetime(createdAt)}
                                        </p>
                                        <p>
                                            Description: ${comments}
                                        </p>
                                    </div>
                                </div>
                                <div class='col-xs-11 text-right'>
                                    <div class='row'>
                                        <h1 style='margin-right: 20px'> 
                                            <span class='bg-blue text-white-custom' style='font-size: 75px;'>${title}</span>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                            <div class='row' style='margin-top: 20px; width: 1100px;'>
                                <div class='col-xs-12'>
                                    <p class='bg-blue text-white-custom' style='font-size: 24px; color: white; font-weight: bold;'>Photos</p>
                                </div>
                            </div>
                            <div class='row' style='width: 1100px; display: flex; flex-wrap: wrap; gap: 10px;'>
                                ${
                                    images.map(item => ` 
                                            <div style='text-align: center; padding-bottom: 10px; flex: 1 1 calc(33.33% - 10px); max-width: calc(33.33% - 10px); object-fit: cover;'>
                                                <img src=${item} />
                                            </div>
                                        `
                                    ).join(' ')
                                }
                            </div>
                            <div class='row' style='width: 1100px; position: fixed; bottom: 45;'>
                                <div class="col-xs-12">
                                    <img src='https://ewrstorage1.blob.core.windows.net/pics/choice.pod.footer.01.png' style='object-fit: fill;' />
                                </div>
                                <div class="col-xs-4">
                                    <p>Created on ${moment().format('MM/DD/YYYY HH:mm:ss')}</p>
                                </div>
                                <div class="col-xs-8" style='text-align: right; padding-right: 100px;'>
                                    <img src='https://ewrstorage1.blob.core.windows.net/pics/eos-logo-1.png' style='height: 50px; width: auto; position: absolute; top: -40px; right: 100px;'  />
                                </div>
                            </div>
                        </div>
                        <script>
                            setTimeout(() => {
                                window.print();
                            }, 1000);
                        </script>
                    </body>
                </html>
            `}}>
        </div>
    );
}

export default GenerateDamageReport;